import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';
import { MemberSubmission } from '../../../../models/submissions/member-submission';
import { IpEmployerSubmission } from '../../../../models/submissions/employer-submissions/ip-employer-submission';
import { StatusPillComponent } from '../../../../ui/pills/status-pill.component';
import { SubmissionStatusDateStringPipe } from '../../pipes/submission-status-date-string-pipe';

@Component({
  selector: 'app-submission-container',
  templateUrl: './submission-container.component.html',
  styleUrls: ['./submission-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, NgIf, StatusPillComponent, SubmissionStatusDateStringPipe]
})
export class SubmissionContainerComponent {
  @Input({ required: true }) submission!: MemberSubmission | IpEmployerSubmission;
  @Input() disabled: boolean = false;
  @Output() submissionClicked = new EventEmitter<MemberSubmission | IpEmployerSubmission>();
}
